// extracted by css-extract-rspack-plugin
export default {"visually_hidden":"uiDMA","visuallyHidden":"uiDMA"};